import React, { type ReactElement, type ReactNode } from 'react';
import clsx from 'clsx';
import type { UseComboboxPropGetters } from 'downshift';
import type { ComboBoxItem } from 'atom-components/combo-boxes/types';
import styles from './menu.module.scss';

type Props = {
  availableItems: ComboBoxItem[];
  isOpen: boolean;
  getMenuProps: UseComboboxPropGetters<unknown>['getMenuProps'];
  children: ReactNode;
};

export default function Menu({
  availableItems,
  isOpen,
  getMenuProps,
  children
}: Props): ReactElement {
  return (
    <ul
      {...getMenuProps()}
      className={clsx(styles.items, {
        [`${styles.itemHidden}`]: !(isOpen && availableItems.length)
      })}
    >
      {children}
    </ul>
  );
}
